import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'shalala';

import { useStore } from '../../../store';
import Table from '../../../facturotopia/table/Table';
import TimbradoSftpStatusBadge from './components/TimbradoSftpStatusBadge';

class TimbradoSftpList extends Component {

  state = {};

  constructor(props) {
    super(props);

    this.state = {
      columns: this.columns,
      selectedRowKeys: []
    }
  }

  get columns() {
    return [
      {
        key: 'created_at',
        title: 'Fecha',
        dataIndex: 'created_at',
        className: 'cell-medium',
      },
      {
        key: 'updated_at',
        title: 'Timbrado',
        dataIndex: 'updated_at',
        className: 'cell-medium',
      },
      {
        key: 'filename',
        title: 'Archivo',
        dataIndex: 'filename',
      },
      {
        key: 'emisor_rfc',
        title: 'Emisor',
        dataIndex: 'emisor_rfc',
      },
      {
        key: 'receptor_rfc',
        title: 'Receptor',
        dataIndex: 'receptor_rfc',
      },
      {
        key: 'total',
        title: 'Total',
        dataIndex: 'total',
      },
      {
        key: 'cfdi_uuid',
        title: 'Cfdi',
        dataIndex: 'cfdi_uuid',
        className: 'cell-xxlarge',
      },
      {
        key: 'status',
        title: 'Status',
        dataIndex: 'status',
        render: renderStatus
      },
    ];
  }

  async componentDidMount() {
    const { data } = this.props;

    if (data.length === 0) {
      const from = moment().subtract(7, 'days').format('YYYY-MM-DD');
      const to = moment().format('YYYY-MM-DD');

      this.paginate({
        page: 1,
        from,
        to
      });
    }
  }

  handleOnPageChange = (page) => {
    this.paginate({ page });
  }

  paginate(params) {
    this.props.paginate(params);
  }

  handleOnPageLimitChange = (limit) => {
    this.paginate({ limit, page: 1 });
  }

  handleRowSelectionChange = ({selectedRowKeys, selectedRows}) => {
    this.setState({
      selectedRowKeys: selectedRowKeys
    }, () => {
      const { onRowSelectionChange } = this.props;

      onRowSelectionChange && onRowSelectionChange({selectedRowKeys, selectedRows});
    });
  }

  getRowSelectionConfig = () => {
    return {
      type: 'checkbox',
      onChange: this.handleRowSelectionChange,
      getCheckboxProps: record => ({
        disabled: record.name === 'Disabled User', // Column uration not to be checked
        name: record.name,
      }),
    }
  }

  getPaginationConfig() {
    const { pagination } = this.props;

    return {
      metadata: pagination,
      onPageChange: this.handleOnPageChange,
      onPageLimitChange: this.handleOnPageLimitChange
    }
  }

  render() {
    const { columns, selectedRowKeys } = this.state;
    const { data, busy, onRowClick } = this.props;

    return (
      <Table
        loading={ busy }
        columns={ columns }
        rowKey={ 'id' }
        data={ data }
        pagination={ this.getPaginationConfig() }
        rowSelection={ {
          selectedRowKeys: selectedRowKeys,
            ...this.getRowSelectionConfig()
          }
        }
        onRowClick={ onRowClick }
      >
      </Table>
    )
  }
}

const renderStatus = (data) => {
  return <TimbradoSftpStatusBadge data={ data } />
}

const mapState = (state) => {
  return state.modulo.timbrado_sftp.list;
}

const mapActions = (actions) => {
  return actions.modulo.timbrado_sftp.list;
}

export default connect(useStore, mapState, mapActions)(TimbradoSftpList);